import {
  AlertCircleIcon,
  CheckCircle2Icon,
  ClockIcon,
  Loader2Icon,
  type LucideIcon,
  MinusCircleIcon,
} from 'lucide-react'

import type { ToolCallStatus } from '@/components/chat/chat-message.interface'

export interface StatusConfig {
  icon: LucideIcon
  isAnimated: boolean
  label: string
  variant: 'default' | 'secondary' | 'destructive' | 'outline'
}

const statusConfigMap: Record<ToolCallStatus, StatusConfig> = {
  pending: {
    icon: ClockIcon,
    isAnimated: false,
    label: 'Pending',
    variant: 'secondary',
  },
  running: {
    icon: Loader2Icon,
    isAnimated: true,
    label: 'Running',
    variant: 'default',
  },
  completed: {
    icon: CheckCircle2Icon,
    isAnimated: false,
    label: 'Completed',
    variant: 'outline',
  },
  'no-data': {
    icon: MinusCircleIcon,
    isAnimated: false,
    label: 'No data retrieved',
    variant: 'secondary',
  },
  error: {
    icon: AlertCircleIcon,
    isAnimated: false,
    label: 'Error',
    variant: 'destructive',
  },
}

export const getStatusConfig = (status: ToolCallStatus): StatusConfig => statusConfigMap[status]
